import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import VueSocketio from './utils/vue-socket-io/src'
import './scripts/element-ui/index'
import env from './scripts/common/env';

// development: '//test-qcgi-kaoji.coding.qq.com',
// production: '//qcgi-kaoji.coding.qq.com',
let socketHost = 'https://qceit-socket.youth.qq.com';

if (env.getIsDevEnv()) {
  socketHost = 'https://test-qceit-socket.youth.qq.com';
// socketHost = 'http://127.0.0.1:10002';
} else if (env.getIsTestEnv()) {
  socketHost = 'https://test-qceit-socket.youth.qq.com';
}

Vue.use(new VueSocketio({
  debug: true,
  connection: socketHost,
  vuex: {
    store, mutationPrefix: 'SET_SOCKET_', actionPrefix: 'setSocket'
  }
}))

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
